import {
  jb_news_overlay_css_default
} from "./chunk.B5HDLC47.js";
import {
  JbModal
} from "./chunk.NTO5HUBR.js";
import {
  disableBodyScroll,
  enableBodyScroll
} from "./chunk.A7Z76YXE.js";
import {
  reset_css_default
} from "./chunk.YAATWOBE.js";
import {
  o
} from "./chunk.DJ2G5F2M.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  Initiable
} from "./chunk.6DHNIVN5.js";
import {
  Spaceable
} from "./chunk.JI7MO3NT.js";
import {
  Animatable
} from "./chunk.V3FEQEPV.js";
import {
  parseHashToObject,
  recenterNavItems
} from "./chunk.JTCOOS2A.js";
import {
  b,
  i
} from "./chunk.BPIW577J.js";
import {
  n,
  r
} from "./chunk.XW2RSTES.js";
import {
  __decorateClass
} from "./chunk.LUIRGYUH.js";

// src/components/jb-news-overlay/jb-news-overlay.ts
var JbNewsOverlay = class extends Spaceable(Animatable(Initiable(i))) {
  constructor() {
    super(...arguments);
    this._responseHtml = "";
  }
  connectedCallback() {
    super.connectedCallback();
    document.addEventListener("keyup", (evt) => {
      if (evt.key === "Escape") {
        this.dispatchEvent(
          new CustomEvent("jb-modal:close", {
            bubbles: true,
            composed: true
          })
        );
      }
    });
  }
  decodeHtml(htmlString) {
    const txt = document.createElement("textarea");
    txt.innerHTML = htmlString;
    return txt.value;
  }
  fetchDataFromApi(url) {
    import("../components/jb-article-back-to-top/jb-article-back-to-top.js").then();
    import("../components/jb-audio-player/jb-audio-player.js").then();
    import("../components/jb-contact-grid/jb-contact-grid.js").then();
    import("../components/jb-contact-item/jb-contact-item.js").then();
    import("../components/jb-gallery/jb-gallery.js").then();
    import("../components/jb-image/jb-image.js").then();
    import("../components/jb-info-block/jb-info-block.js").then();
    import("../components/jb-listing/jb-listing.js").then();
    import("../components/jb-news-page-hero/jb-news-page-hero.js").then();
    import("../components/jb-publication-download/jb-publication-download.js").then();
    import("../components/jb-quote/jb-quote.js").then();
    import("../components/jb-text-with-image/jb-text-with-image.js").then();
    import("../components/jb-video/jb-video.js").then();
    fetch(url).then((response) => response.json()).then((data) => {
      this._responseHtml = data.html;
    });
  }
  firstUpdated() {
    this.fetchDataFromApi(this.url);
    this.dispatchEvent(
      new CustomEvent("jb-stackable:register-outro-callback", {
        bubbles: true,
        composed: true,
        detail: {
          callback: async () => {
            window.history.replaceState("", "", window.location.pathname + window.location.search);
          }
        }
      })
    );
  }
  _getContentSpacingProperties() {
    return { grid: true, colsMdUp: 8 };
  }
  render() {
    return b`<div
      class="news-overlay"
      tabindex="0"
    >
      ${o(this.decodeHtml(this._responseHtml))}
    </div>`;
  }
};
JbNewsOverlay.styles = [reset_css_default, jb_news_overlay_css_default];
__decorateClass([
  n()
], JbNewsOverlay.prototype, "url", 2);
__decorateClass([
  r()
], JbNewsOverlay.prototype, "_responseHtml", 2);
JbNewsOverlay = __decorateClass([
  customElement("jb-news-overlay")
], JbNewsOverlay);
bindEvents();

// src/components/jb-news-overlay/jb-news-overlay-controller.ts
var newsLinksRegister = {};
var JbNewsOverlayController = class {
  constructor() {
    this.overlay = void 0;
  }
  async close() {
    if (this.overlay) {
      const animatedElement = document.querySelector("jb-news-overlay");
      animatedElement.contentChildren = Array.from(animatedElement.shadowRoot.querySelectorAll("div.news-overlay"));
      await animatedElement.hide();
      this.overlay.unstack();
      enableBodyScroll(animatedElement);
      recenterNavItems();
    }
    this.overlay = void 0;
  }
  // `urlOverride` lets a caller open the overlay for an item whose content URL it already knows,
  // instead of looking it up from a teaser that registered the item.
  handleHashChange(target, urlOverride) {
    const { hash } = window.location;
    const cleanHash = hash.startsWith("#") ? hash.substring(1) : hash;
    const hashParams = parseHashToObject(cleanHash);
    if (!hash || !hashParams.overlayNews) {
      this.close();
      return;
    }
    const translationId = Number(hashParams.overlayNews);
    const url = urlOverride ?? newsLinksRegister[translationId];
    if (!url) {
      this.close();
      return;
    }
    const jbNewsOverlay = new JbNewsOverlay().init({
      props: { background: "smoke-light", url, withSpacing: true, slot: "content" }
    });
    this.overlay = new JbModal().init({
      props: {
        color: "gray",
        hasLogo: true,
        svgLogo: this.svgLogo,
        newAnimation: true,
        returnFocusTo: target,
        ariaLabels: {
          label: hashParams.overlayLabel ?? void 0,
          close: hashParams.overlayClose ?? void 0
        }
      },
      childNodes: [jbNewsOverlay]
    });
    if (this.overlay) {
      this.overlay.stack();
      customElements.whenDefined("jb-news-overlay").then(async () => {
        setTimeout(() => {
          jbNewsOverlay.contentChildren = Array.from(jbNewsOverlay.shadowRoot.querySelectorAll("div.news-overlay"));
        }, 0);
        disableBodyScroll(jbNewsOverlay, { allowTouchMove: () => true });
        recenterNavItems();
        await jbNewsOverlay.reveal();
      });
    }
  }
  open(event) {
    const customEvent = event;
    if (!customEvent.detail.newsOverlay) {
      return;
    }
    customEvent.stopPropagation();
    customEvent.detail.clickEvent.preventDefault();
    customEvent.detail.clickEvent.stopPropagation();
    const baseUrl = window.location.href.split("#")[0];
    let newUrl = `${baseUrl}#overlayNews=${customEvent.detail.newsOverlay.id}`;
    if (customEvent.detail.overlayAriaLabels?.label) {
      newUrl += `&overlayLabel=${customEvent.detail.overlayAriaLabels.label}`;
    }
    if (customEvent.detail.overlayAriaLabels?.close) {
      newUrl += `&overlayClose=${customEvent.detail.overlayAriaLabels.close}`;
    }
    window.open(newUrl, "_self");
    this.svgLogo = customEvent.detail.svgLogo;
    this.handleHashChange(customEvent.detail.linkTag);
  }
};
var controller = new JbNewsOverlayController();
function bindEvents() {
  document.body.addEventListener("jb-modal:close", () => {
    controller.close();
  });
  document.body.addEventListener("jb-link:initialized", (event) => {
    const customEvent = event;
    if (!customEvent.detail.newsOverlay) {
      return;
    }
    newsLinksRegister[customEvent.detail.newsOverlay.id] = customEvent.detail.newsOverlay.url;
  });
  document.body.addEventListener("jb-link:clicked", (event) => {
    controller.open(event);
  });
}
async function openNewsOverlayFromDeepLink(buildUrl) {
  const { hash } = window.location;
  const cleanHash = hash.startsWith("#") ? hash.substring(1) : hash;
  const { overlayNews } = parseHashToObject(cleanHash);
  if (!overlayNews) {
    return;
  }
  const url = newsLinksRegister[Number(overlayNews)] ?? buildUrl(overlayNews);
  try {
    const response = await fetch(url);
    if (!response.ok) {
      return;
    }
  } catch {
    return;
  }
  controller.handleHashChange(document.body, url);
}

export {
  bindEvents,
  openNewsOverlayFromDeepLink,
  JbNewsOverlay
};
